var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68548 5.92871H1.2419V16.9101H4.68548V5.92871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 5.69094C13.8739 5.67507 13.739 5.66714 13.6041 5.6592C11.676 5.57986 10.589 6.72243 10.2081 7.21437C10.105 7.34926 10.0574 7.4286 10.0574 7.4286V5.96072H6.76454V16.9421H10.0574H10.2081C10.2081 15.8233 10.2081 14.7125 10.2081 13.5937C10.2081 12.9907 10.2081 12.3877 10.2081 11.7847C10.2081 11.0388 10.1526 10.2454 10.5255 9.56299C10.8429 8.9917 11.4142 8.70606 12.0569 8.70606C13.9611 8.70606 14.0008 10.4278 14.0008 10.5865C14.0008 10.5945 14.0008 10.6024 14.0008 10.6024V16.9897H17.4444V9.82483C17.4444 7.37306 16.1987 5.92898 14.0008 5.69094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96379 4.50876C4.06808 4.50876 4.96329 3.61356 4.96329 2.50926C4.96329 1.40497 4.06808 0.509766 2.96379 0.509766C1.8595 0.509766 0.964294 1.40497 0.964294 2.50926C0.964294 3.61356 1.8595 4.50876 2.96379 4.50876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.77790e1821fb0e8b97b1de098ecf58e3.svg";
export { ForwardRef as ReactComponent };